export default __webpack_public_path__ + "static/media/SIFA_NL_SEQ13.061976ef.mp3";